import Swal from 'sweetalert2';

export default {
  loading: (options) => {
    Swal.close();
    Swal.fire({
      icon: 'info',
      title: options.title,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      // SweetAlert2 scrolls the page to the top when displaying an information modal.
      // We set heightAuto to false to prevent this, see: https://deepwiki.com/search/heightauto_3c8b4673-a03e-4aa3-8afc-d74b481fa8e8.
      heightAuto: false,
    });
    Swal.showLoading();
  },
  success: (options) => {
    Swal.close();
    Swal.fire({
      icon: 'success',
      title: options.title,
      showConfirmButton: false,
      heightAuto: false,
    });
    setTimeout(() => {
      Swal.close();
    }, 1500);
  },
  error: (options) => {
    Swal.close();
    Swal.fire({
      icon: 'error',
      title: options.title,
      text: options.text,
      confirmButtonText: 'Got it!',
      heightAuto: false,
    });
  },
};
